module.exports = __webpack_public_path__ + "9924546651cbc9615f9fc288698d6293.png";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/games/slots/betsoft/assets/804.png
// module id = 1708
// module chunks = 2